import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Type } from "@ebscois/react-component-library";
import { RelatedContentWrap, RelatedContentLink } from "./_styled";
import { logRelatedContentLinkClicked } from "../../util/analytics";

const RightRailRelatedContent = ({
  label,
  relations,
  testId,
  telemetryData,
}) => {
  return (
    <>
      {relations?.length > 0 && (
        <div data-testid={testId}>
          <Type
            color="headingprimary"
            element="h2"
            styledAs="h5"
            fontFamily="secondary"
          >
            {label}
          </Type>
          {relations.map((rc, idx) => (
            <RelatedContentWrap key={idx}>
              <Type
                element="p"
                fontSize="xs"
                textTransform="uppercase"
                data-testid="related-content-pubtype"
              >
                {rc.prettyPubtype}
              </Type>
              <RelatedContentLink
                linkComponent={Link}
                href={rc.link}
                data-testid="related-content-link"
                onClick={() =>
                  logRelatedContentLinkClicked({
                    ...telemetryData,
                    title: rc.title,
                  })
                }
              >
                {rc.title}
              </RelatedContentLink>
            </RelatedContentWrap>
          ))}
        </div>
      )}
    </>
  );
};

RightRailRelatedContent.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  telemetryData: PropTypes.object.isRequired,
  relations: PropTypes.arrayOf(
    PropTypes.shape({
      prettyPubtype: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }).isRequired
  ),
};

RightRailRelatedContent.displayName = "RightRailRelatedContent";

export default RightRailRelatedContent;
